import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-746007f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-dark-gray invoice__wrapper" }
const _hoisted_2 = { class: "p-d-flex" }
const _hoisted_3 = { class: "table__wrapper" }
const _hoisted_4 = { class: "medium p1 text-white p-pb-3" }
const _hoisted_5 = { class: "p2 text-light-gray" }
const _hoisted_6 = { class: "p-text-right" }
const _hoisted_7 = { class: "p2 text-light-gray" }
const _hoisted_8 = { class: "p-text-right" }
const _hoisted_9 = { class: "p2 text-light-gray" }
const _hoisted_10 = { class: "p-text-right" }
const _hoisted_11 = { class: "p2 text-light-gray" }
const _hoisted_12 = { class: "p-text-right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = { class: "p-d-flex p-ai-center p-jc-between p-pt-3" }
const _hoisted_15 = { class: "medium text-white p1" }
const _hoisted_16 = { class: "medium text-white p1" }
const _hoisted_17 = { class: "table__wrapper p-ml-4" }
const _hoisted_18 = { class: "medium p1 text-white p-pb-3" }
const _hoisted_19 = { class: "p2 text-light-gray p-pb-3" }
const _hoisted_20 = { class: "p2 text-light-gray p-pb-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "p2 text-white" }, "CODERHOUSE S.R.L."),
  /*#__PURE__*/_createElementVNode("td", { class: "p2 text-white" }, "30714528749")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.copies.billAmount.title), 1)
          ]),
          _createElementVNode("tr", _hoisted_5, [
            _createElementVNode("td", null, _toDisplayString(_ctx.copies.billAmount.totalReview), 1),
            _createElementVNode("td", _hoisted_6, "$" + _toDisplayString(_ctx.data.reviewsAmount), 1)
          ]),
          _createElementVNode("tr", _hoisted_7, [
            _createElementVNode("td", null, _toDisplayString(_ctx.copies.billAmount.totalAfterclass), 1),
            _createElementVNode("td", _hoisted_8, "$" + _toDisplayString(_ctx.data.complementariesAmount), 1)
          ]),
          _createElementVNode("tr", _hoisted_9, [
            _createElementVNode("td", null, _toDisplayString(_ctx.copies.billAmount.baseAmount), 1),
            _createElementVNode("td", _hoisted_10, "$" + _toDisplayString(_ctx.data.baseAmount), 1)
          ]),
          _createElementVNode("tr", _hoisted_11, [
            _createElementVNode("td", null, _toDisplayString(_ctx.copies.billAmount.totalAdditional), 1),
            _createElementVNode("td", _hoisted_12, "$" + _toDisplayString(_ctx.data.additionalAmount), 1)
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.copies.billAmount.totalBill), 1),
          _createElementVNode("span", _hoisted_16, "$" + _toDisplayString(_ctx.data.amount), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.copies.information.title), 1),
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.copies.information.entity), 1),
            _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.copies.information.cuit), 1)
          ]),
          _hoisted_21
        ])
      ])
    ]),
    _createVNode(_component_Button, {
      label: 'Cargar factura',
      class: "p-d-block p-ml-auto p-mt-4",
      onClick: _ctx.handleUpload
    }, null, 8, ["onClick"])
  ]))
}